import { Field, ErrorMessage } from 'formik';
const FinancingType = (props) => {
    return (
        <>
            <div className='col-10'>
                <div className='row m-0 mt-4 px-3 text-start'>
                    <div className='col-4'>
                        <label className='form-label text-neutral-800 font-b3 mb-1'>Financing Type</label>
                        <Field as='select' name='financing_type' className='form-control font-b2' disabled>
                            <option value='' label='Select Option' />
                            <option value='deal_financing'>Deal Financing</option>
                        </Field>

                        <ErrorMessage
                            name='financing_type'
                            component='div'
                            className='error-message font-b4 text-error-700'
                        />
                    </div>
                </div>
            </div>
            <div className='col-12 px-3 pt-1'>
                <hr className=' mt-4 mb-0' />
            </div>
        </>
    );
};

export default FinancingType;
